<template>
  <v-autocomplete
    color="primary"
    hide-no-data
    v-model="accountUserSelected"
    :clearable="!unclearable"
    :items="accountUserItems"
    :loading="loading"
    :search-input.sync="accountUserSearch"
    item-text="Description"
    item-value="id"
    item-disabled="disabled"
    :label="noLabel ? '' : $t('PurchasePlansDetail.Fields.purchase_user')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    :error-messages="errorMessages"
  ></v-autocomplete>
</template>

<script>
import PurchaseUserTasks from "@/api/purchase_user_tasks";

export default {
  name: "SearcherPurchaseUser",

  props: {
    value: Object,
    noLabel: Boolean,
    dense: Boolean,
    unclearable: Boolean,
    disabledItems: Array,
    errorMessages: Array,
    stockIds: Array,
  },

  computed: {
    accountUserItems() {
      return this.accountUser.map((user) => {
        const Description = user.name
        const disabled = this.disabledItems
          ? this.disabledItems.find(
              (disabledItem) => disabledItem.id == user.id
            )
          : false;
        return Object.assign({}, user, { Description, disabled });
      });
    },
  },

  data: () => ({
    accountUser: [],
    loading: false,
    accountUserSearch: "",
    accountUserSelected: null,
  }),

  mounted() {
    this.getAccountUsersFromAPI();
  },

  methods: {
    getAccountUsersFromAPI() {
      this.loading = true;
      PurchaseUserTasks.getAccountUsers({stock_ids: this.stockIds})
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.accountUser = response.data.users;
            }
            this.loading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.loading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.accountUserSelected = this.value;
      },
    },
    stockIds: {
      handler() {
        if (this.stockIds) {
          this.getAccountUsersFromAPI();
        }
      }
    },
    accountUserSelected: {
      handler() {
        this.$emit("input", this.accountUserSelected);
        this.$emit("change");
      },
    },
  },
};
</script>
